/**
 * Die eine Entscheidung im Start der Vorbereitung, die nichts mit React zu tun
 * hat: Welche Anfragen laufen überhaupt los?
 *
 * Der Grund für die eigene Funktion ist der LLM-Aufruf. „Ohne
 * Zusammenfassungen weiter" darf die Zusammenfassungs-Mutation nicht nur
 * verwerfen, sondern muss sie **gar nicht erst** absetzen — sonst kostet der
 * abgewählte Schalter trotzdem Modellzeit. Das ist in der Komponente nicht
 * prüfbar, hier schon.
 */
export interface GenerationPlan {
  /** KI-Zusammenfassungen anfordern (`/presentation/summaries`). */
  summaries: boolean;
  /**
   * Termine der Endfolie laden. Hängt NICHT an den Zusammenfassungen: Die
   * Abschlussfolie zeigt sie auch dann, wenn die Folien auf den letzten
   * öffentlichen Kommentar zurückfallen.
   */
  events: boolean;
}

export function planGeneration(o: { withSummaries: boolean }): GenerationPlan {
  return { summaries: o.withSummaries, events: true };
}
